import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
import { TABLET_QUERY_MAX_WIDTH, MACBOOK_PRO_MAX_WIDTH } from "/constants/vp-sizes";
import { TOP_LAYER } from "constants/z-index";
const BACKGROUND_GRADIENT = "linear-gradient(#1c0c4d 0%, #452caa 100%)";
const TEXT_COLOR = "#d6ccff";
const PHONE_TEXT_COLOR = "#727b9a";
export const StyledHubspotOnDarkBackgroundFormComponent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  background: ${BACKGROUND_GRADIENT};
  color: ${Colors[WHITE_COLOR_NAME]};
  padding: 80px 0;
  .side-by-side-text-and-asset .side-by-side-content {
    display: flex;
    justify-content: space-between;
    gap: 80px;
    .full-paragraph-component-wrapper {
      height: 100%;
      display: flex;
      padding: 0;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
        height: 100%;

        .title-wrapper {
          margin-bottom: 32px;
          font-size: 2.75rem;
        }

        .subtitle-wrapper {
          margin-bottom: 24px;
          .paragraph-wrapper .paragraph-body {
            font-size: 1rem;
            color: ${TEXT_COLOR};
          }
        }

        .values-list-wrapper {
          display: grid;
          grid-template-columns: repeat(2, 235px);
          grid-gap: 36px;
          .value-item {
            display: flex;
            line-height: 24px;
            gap: 12px;
            font-size: 0.875rem;
            .vi-icon .picture-component {
              display: flex;
              height: 20px;
            }
          }
        }
      }

      .logos-wrapper {
        display: flex;
        flex-direction: column;
        .sentence-above-logos {
          .paragraph-wrapper .paragraph-body {
            font-size: 0.875rem;
            color: ${TEXT_COLOR};
          }
          margin-bottom: 24px;
        }
        .logos {
          display: flex;
          flex-wrap: wrap;
          gap: 40px;
          width: 480px;
          justify-content: space-between;
          .logo-wrapper {
            .picture-component {
              img {
                height: 50px;
              }
            }
          }
        }
      }
    }
    .image-wrapper {
      overflow: unset;
      .form-wrapper {
        .hubspot-contact-form-wrapper .base-form {
          width: 460px;
          margin: 0;
          padding: 32px;
          .form-title-wrapper {
            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
            text-align: center;
            .monday-markup-language-component {
              font-weight: 600;
              font-size: 1.75rem;
            }
          }
          .contact-form-row {
            margin-bottom: 12px;
            .form-input-wrapper {
              .required-error{
              font-size: 0.7875rem;
              }           
              padding: 0 5px 0 5px;
              .generic-form-input-component {
                .form-input-wrapper {
                  margin-bottom: 10px;
                  padding: 0;
                  .hp-input {
                    height: 46px;
                    border-radius: 6px;
                    &.hp-textarea-input {
                      height: 80px;
                    }
                    &.hp-phone-input {
                      .react-tel-input {
                        height: 46px;
                        input {
                          height: 46px;
                        }
                        .flag-dropdown {
                          .country-list {
                            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
                          }
                        }
                      }
                      .react-tel-input::before {
                        content: "*";
                        position: absolute;
                        top: 4px;
                        left: 44px;
                        color: ${PHONE_TEXT_COLOR};
                        z-index: ${TOP_LAYER};
                        font-family: Poppins;
                      }
                    }
                  }
                  .hp-multi-select-input {
                    .react-select__control {
                      min-height: 46px;
                      border-radius: 6px;
                    }
                  }
                  #company_size {
                    padding-right: 28px;
                  }
                  .react-select__menu{
                   z-index:${TOP_LAYER};
                  }
                }
              }
            }
          }

          .privacy-notice-wrapper .privacy-notice {
            color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
            margin-top: 24px;
          }
        }
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .side-by-side-text-and-asset .side-by-side-content .full-paragraph-component-wrapper {
      max-width: 480px;
      .logos-wrapper {
        margin-top: 120px;
      }
    }
  }

  @media (max-width: ${MACBOOK_PRO_MAX_WIDTH}) {
    .side-by-side-text-and-asset .side-by-side-content {
      gap: 32px;
    }
  }

  &.short-form {
    .side-by-side-text-and-asset .side-by-side-content .image-wrapper {
      display: flex;
      height: 100%;
      align-items: flex-start;
    }
  }

  @media (min-width: ${TABLET_QUERY_MAX_WIDTH}) {
    &.short-form {
      height:800px;
    }
`;
